var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloud",class:{ odd: _vm.odd, singleChar: _vm.singleChar }},[_c('div',{staticClass:"text-container"},[_vm._v(_vm._s(_vm.text))]),_c('Cloud',{staticClass:"cloud-svg"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }